'use client';

import React, { useEffect } from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import useUserStore from '@/lib/hooks/zustand-stores/use-user-store';
import { getCurrentUserObjId } from '@/lib/utils'
import { useLogger } from '@/lib/hooks/useLogger';
const BaseUserInitializer: React.FC = () => {
  const refreshUser = useUserStore(state => state.refreshUser);
  const setLoading = useUserStore(state => state.setLoading);
  const { user: clerkUser } = useUser();

  // 1. Load and refresh the user when `userId` and `clerkUser` are available
  useEffect(() => {
    const getUser = async () => {
      if (clerkUser) {
        const _userId = await getCurrentUserObjId(clerkUser)
        refreshUser(_userId, clerkUser).then(() => setLoading(false));
      }
    }
    getUser()
  }, [clerkUser?.id]);
  return null;
};

export default BaseUserInitializer;
